const spotifyTracks = [{
    id: 'baiao',
    title: 'Baião',
    src: "https://open.spotify.com/embed/track/1sFOvHAHQkFcwkvKGt3FIZ?utm_source=generator"
  }, {
    id: 'vira',
    title: 'Virá',
    src: "https://open.spotify.com/embed/track/5ZnsS93nB1183WZjjhV67W?utm_source=generator"
  },{
    id: 'floreser',
    title: 'Flor e Ser',
    src: "https://open.spotify.com/embed/track/1dae9THBJDc7vFqC4nxfel?utm_source=generator"
  }]
  
const youtubeTracks = [
  {
    id: 'virayt',
    title: 'Virá', 
    src: "https://www.youtube.com/embed/g-YJ4QLazhg?si=waXjbUaQbA7kNP3G"
  },
  {
    id: 'floreseryt',
    title: 'Flor e Ser', 
    src: "https://www.youtube.com/embed/Nb5mU5fvI20?si=rELvolSTBZv-CNKX"
  }
]

const tracks = { spotifyTracks,youtubeTracks }

export default tracks